export default __webpack_public_path__ + "static/media/synthetic-place.062e49a4.gif";